import type { SxProps, Theme } from "@mui/material/styles";

type DashboardToggleButtonGroupOptions = {
  vertical?: boolean;
  fullWidth?: boolean;
  /** Minimum 44×44px hit area for compact dashboard chrome toggles. */
  compactTouchTargets?: boolean;
};

/** Bordered toggle group — shared by Schedule toolbar and Dashboard2 controls (incl. dark mode). */
export const dashboardToggleButtonGroupSx = (
  theme: Theme,
  options?: DashboardToggleButtonGroupOptions
): SxProps<Theme> => {
  const isDark = theme.palette.mode === "dark";
  const isVertical = options?.vertical ?? false;

  return {
    flexShrink: 0,
    borderRadius: 2,
    overflow: "hidden",
    border: 1,
    borderColor: "divider",
    bgcolor: "background.paper",
    ...(options?.fullWidth ? { flex: 1, width: "100%" } : {}),
    ...(isVertical
      ? {
          flexDirection: "column",
          flexWrap: "nowrap",
          alignItems: "stretch"
        }
      : {}),
    "& .MuiToggleButton-root": {
      px: 1.5,
      py: 1,
      border: 0,
      borderRadius: 0,
      ...(options?.compactTouchTargets
        ? {
            minWidth: 44,
            minHeight: 44
          }
        : {}),
      ...(isVertical
        ? {
            width: "100%",
            justifyContent: "flex-start"
          }
        : {}),
      ...(isDark ? { color: theme.palette.text.secondary } : {})
    },
    ...(isDark
      ? {
          "& .MuiToggleButton-root.MuiToggleButton-primary.Mui-selected": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.common.white} !important`,
            "&:hover": {
              backgroundColor: `${theme.palette.primary.main} !important`,
              color: `${theme.palette.common.white} !important`
            },
            "& .MuiSvgIcon-root, & .MuiTypography-root": {
              color: "inherit !important"
            }
          }
        }
      : {})
  };
};
